export const PAYMENT_PLAN = {
  id: null,
  type: null,
  value: 0,
  properties: null,
}

export const PAYMENT_ITEM = {
  id: null,
  type: null,
}

export const ORDER_PAYMENT = {
  to_generate_voucher: false,
  to_generate_debt: false,
  customer_id: null,
  change_value: 0,
  paymentItems: [PAYMENT_ITEM],
  paymentPlans: [PAYMENT_PLAN],
}
